import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidSilkColor from "../../../../service/visibleValidator/isValidSilkColor"
import SilkPrintColorImage from "./SilkPrintColorImage"

const シルク印刷色 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { silkColor: shouldShow } = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)

  const white = <SilkPrintColorImage values={values} silkColor="white" />
  const black = <SilkPrintColorImage values={values} silkColor="black" />
  const yellow = <SilkPrintColorImage values={values} silkColor="yellow" />

  return (
    <OneClickField
      isShow={shouldShow}
      disabled={disabled.silkColor}
      legend="シルク印刷色"
      helpURL={HELP_LINKS.シルク印刷色}
    >
      <RadioGroup
        name={FIELD_NAMES.シルク印刷色}
        selectedValue={values.silkColor}
        onChange={handlers.radio}
        disabled={disabled.silkColor}
        shouldRender={(value) => isValidSilkColor(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["白(リジッド)"].value} prefixNode={white}>
            白
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["黒(リジッド)"].value} prefixNode={black}>
            黒
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["黄(リジッド)"].value} prefixNode={yellow}>
            黄
          </Radio>

          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["白(フレキシブル)"].value} prefixNode={white}>
            白
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["黒(フレキシブル)"].value} prefixNode={black}>
            黒
          </Radio>

          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["白(メタル)"].value} prefixNode={white}>
            白
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["黒(メタル)"].value} prefixNode={black}>
            黒
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷色["黄(メタル)"].value} prefixNode={yellow}>
            黄
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.silkColor} />
    </OneClickField>
  )
}

export default シルク印刷色
